import { RootState } from '@/store/store';

import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';

export const useAcl = () => {
	// // Ensure context exists
	// if (!context || !context.user) {
	// 	return { can: () => false, canIndex: () => -1, canAll: () => false };
	// }

	const currUser = useSelector((state: RootState) => state.user.user);

	const aclMethods = currUser?.role?.methods;
	const can = useCallback(
		(action: string[]) => {
			if (action !== undefined) {
				if (currUser) {
					if (currUser?.isAdmin) return true;
					if (action?.some((d) => d === 'true')) return true;

					return aclMethods?.some((object) => action.includes(object.action));
				}
				return false;
			}
			return false;
		},
		[aclMethods, currUser]
	);

	const canIndex = useCallback(
		(action: string[], defaultAction?: string) => {
			if (currUser?.isAdmin) return defaultAction ? action.indexOf(defaultAction) : 0;
			const foundDefaultAction = aclMethods?.find((acl) => acl?.action === defaultAction)?.action;
			const foundAction = action.find((a) => aclMethods?.some((acl) => acl?.action === a));
			return foundDefaultAction
				? action.indexOf(foundDefaultAction)
				: foundAction !== undefined
					? action.indexOf(foundAction)
					: -1;
		},
		[aclMethods, currUser]
	);

	const canAll = useCallback(
		(action: string[]) => {
			if (action !== undefined) {
				if (currUser) {
					if (currUser?.isAdmin) return true;

					const verifActions = action.map((_, key) =>
						aclMethods?.some((object) => object.action === action[key])
					);
					return verifActions.every((el) => el === true);
				}
				return false;
			}
			return false;
		},
		[aclMethods, currUser]
	);
	return { can, canIndex, canAll };
};
